import request from '@/modules/base/util/request'

import config from './config'

const { accountUrls } = config

const DocumentService = {

  createAccount: () => {
    return request(accountUrls.createAccount, {
      method: 'PUT',
      auth: true,
      isConcurrent: true,
      timeout: 6e4, // 1 Minute
    }).then((response) => {
      const { body: { data } } = response
      return data
    })
  },

  fetchAccount: () => {
    return request(accountUrls.fetchAccount, {
      auth: true,
      isConcurrent: true,
    }).then((response) => {
      const { body: { data } } = response
      return data
    })
  },

  getLogin: () => {
    return request(accountUrls.getLogin, {
      auth: true,
      isConcurrent: true,
    }).then((response) => {
      const { body: { data } } = response
      return data
    })
  },

  updateApiKey: (apiKey) => {
    return request(accountUrls.updateApiKey, {
      method: 'POST',
      auth: true,
      isConcurrent: true,
      data: {
        apiKey,
      },
    }).then((response) => {
      const { body: { data } } = response
      return data
    })
  },

  updateSettings: (settings) => {
    return request(accountUrls.updateSettings, {
      method: 'put',
      auth: true,
      isConcurrent: true,
      data: {
        ...settings,
      },
    }).then((response) => {
      const { body: { data } } = response
      return data
    })
  },
}

export default DocumentService
